import React, { useMemo } from 'react'
import TextEvent from './scanHistoryComponents/TextEvent';
import { Machine } from '../../../ts/Connections';
import { TextEventProps, MachineEvent } from '../../../ts/MachineEvent';
import { Cargo } from '../../../ts/Cargo';
import ScanSkeleton from './scanHistoryComponents/ScanSkeleton';
import TextScanEvent from './scanHistoryComponents/TextScanEvent';
import ScanHistoryList, { TimelineItem } from './ScanHistoryList';

interface ScanHistoryProps {
    selectedScanIndex: number;
    setSelectedScanIndex: (index: number) => void;
    cargoResponses: Cargo[];
    machineEvents: MachineEvent[];
    setOpenScanDetails: (open: boolean) => void;
    machine: Machine;
    onEndReached?: () => void;
    onStartReached?: () => void;
    onAtTopChange?: (atTop: boolean) => void;
    loadingOlder?: boolean;
    listHeight?: string | number;
    refreshEnabled?: boolean;
}

function ScanHistory(props: ScanHistoryProps) {
    const { selectedScanIndex, setSelectedScanIndex, cargoResponses, machineEvents, machine,
        onEndReached, onStartReached, onAtTopChange, loadingOlder, listHeight, refreshEnabled } = props

    // Create a combined timeline of machine events and scan events (and sort by timestamp)
    const timelineEvents = useMemo(() => {
        return [...machineEvents, ...cargoResponses].sort((a, b) => b.timeStamp.getTime() - a.timeStamp.getTime());
    }, [machineEvents, cargoResponses]);

    const handleListItemClick = (
        _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
    ) => {
        setSelectedScanIndex(index);
    };

    const openDetailsModal = function () {
        console.log('Scan Details Modal Disabled on Medium view')
    }

    const renderRow = (index: number, historyEvent: TimelineItem) => {
        if (historyEvent instanceof Cargo) {
            const cargoIndex = cargoResponses.findIndex((c) => c.cargoFolder === historyEvent.cargoFolder);
            const resolvedIndex = cargoIndex >= 0 ? cargoIndex : index;
            return (
                <TextScanEvent
                    scanFailure={historyEvent.dimensionCode === "0" ? false : true}
                    cargoResponse={historyEvent}
                    cargoResponseIndex={resolvedIndex}
                    handleListItemClick={handleListItemClick}
                    selectedScanIndex={selectedScanIndex}
                    openDetailsModal={openDetailsModal}
                    machine={machine}
                />
            )
        }
        if (historyEvent instanceof TextEventProps) {
            return <TextEvent {...historyEvent} />
        }
        if (historyEvent instanceof MachineEvent && !historyEvent.complete) {
            return <ScanSkeleton />
        }
        return <div />
    }

    return (
        <ScanHistoryList
            data={timelineEvents}
            itemContent={renderRow}
            onEndReached={onEndReached}
            onStartReached={onStartReached}
            onAtTopChange={onAtTopChange}
            loadingOlder={loadingOlder}
            listHeight={listHeight}
            refreshEnabled={refreshEnabled}
        />
    )
}

export default React.memo(ScanHistory);
